<script lang="ts">
    import Fa from 'svelte-fa'
    import {link,push} from 'svelte-spa-router'
    import * as qs from 'qs';
    import { faLine } from '@fortawesome/free-brands-svg-icons';
    import { faHome,faWallet,faMoneyBillTransfer,faClockRotateLeft,faHandHoldingDollar,faFutbolBall,faCogs,faHouse,faCashRegister,faSackDollar,faMoneyBill,faGifts } from '@fortawesome/free-solid-svg-icons';

    import Time from "svelte-time";
    import Swal from 'sweetalert2'
    import Themes from '../themes/themes.svelte';

    let balance = 0.00
    let acc_name =""

    let numnoti = ''
    let platformList =[]
    let themes=''
    let dataSetting = JSON.parse(window.localStorage.getItem('setting'))
    
    //console.log(themes)
    if(dataSetting.themes){
        themes = dataSetting.themes
    }else{
        themes = 'default'
    }
    async function getBalance() {
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/getbalance", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) {
            balance = json.payload.balance.toLocaleString('th-TH')
            acc_name = json.payload.username
		} else {
            window.localStorage.clear();
            push('/')
            throw new Error(json);
		}
    }
    getBalance()

    async function checkPromotion() {
        let couponx = ""
        Swal.fire({
            title: "กรุณาระบุกรอก Code",
            input: "text",
            inputAttributes: {
                autocapitalize: "off",
                align: "center"
            },
            showCancelButton: true,
            confirmButtonText: "ยืนยัน",
            cancelButtonText: "ยกเลิก",
            showLoaderOnConfirm: true,
            preConfirm: async (login) => {
                try {
                    couponx = login
                    const res = await fetch(window.localStorage.getItem("apiurl")+"member/getpromotioncode", {
                        method: 'POST',
                        headers:{
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                            'x-api-appid': window.localStorage.getItem("appid")
                        },
                        body: qs.stringify({
                            _id:login
                        })
                    })
                    const json = await res.json()
                    return json
                } catch (error) {
                    Swal.showValidationMessage(`
                        Request failed: ${error}
                    `);
                }
            },
            allowOutsideClick: () => !Swal.isLoading()
        }).then((result) => {
            
            console.log(result)
            if (result.isConfirmed) {
                // Swal.fire({
                // title: `${result.value.login}'s avatar`,
                // imageUrl: result.value.avatar_url
                // });
                if(result.value.statusCode == 200){
                    window.localStorage.setItem("coupon",couponx)
                    push('/promotion/'+result.value.payload._id)
                    
                }else{
                    window.localStorage.setItem("coupon","")
                    Swal.fire(result.value.message)
                }
            }else{
                
            }
        });
    }

    async function countMessage() {
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/countmessage", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) { 
            if(json.payload.total>=1){
                numnoti = json.payload.total
            }else{
                numnoti = ''
            }
            
		} else {
            throw new Error(json);
		}
    }
    countMessage()
    async function getPlatform() {
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/getplatformlist", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) {
            platformList = json.payload
            let dataSetting = window.localStorage.getItem("setting")
            let vSetting = JSON.parse(dataSetting)
            if(vSetting.platform!=""){
                let newPlatform = []
                let xPlatform = JSON.parse(vSetting.platform)
                for await (const iterator of platformList) {
                    if(xPlatform.indexOf(iterator._id)!=-1){
                        newPlatform.push(iterator)
                    }
                }
                platformList = newPlatform
            }
		} else {

            throw new Error(json);
		}
    }
    getPlatform()

    let isRank = false
    let rankname = ""
    let rankimg = ""
    let percentagex = 0

    async function getRank() {
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/getranking", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) {
            if(json.payload.status){
                rankname = json.payload.rank_name
                rankimg = json.payload.rank_img
                let setA = json.payload.up_max-json.payload.up_min
                let setB = json.payload.scores-json.payload.up_min
                percentagex = Math.ceil((100*setB)/setA)
                isRank = true
            } 
		} else {
            
		}
    }
    getRank()
    
</script>


    <div class="navbar fixed-bottom bg-transparent p-0 footers-themes {themes}">
        <div class="container content-wrapper bg-warMain " style="position: relative;" >
            <!-- <div class="alert-icon">
                <img src="./assets/images/promote.png" class="img-fluid" style="max-height: 30px;cursor:pointer;" on:click={() => push('/message')}>
                {#if numnoti!=''}
                <span class="position-absolute ps-1 pe-1 top-0 start-75  translate-middle bg-danger border border-light rounded-pill text-white text-center" >
                    {numnoti}
                    <span class="visually-hidden">New alerts</span>
                  </span>
                  {/if}
            </div> -->
            {#if isRank}
            <div class="alert-icon">
                <img src="{rankimg}" class="img-fluid" style="max-height: 30px;cursor:pointer;" on:click={() => push('/ranking')}>
            </div>
            {/if}
            <div class="pro-code">
                <img src="./assets/images/giftbox.png" class="img-fluid" style="max-height: 30px; cursor:pointer;" on:click={() => checkPromotion()}>
            </div>
            <div class="row p-0 blog-footer">
                <div class="d-flex flex-row p-0 text-center justify-content-around pt-2 pb-1">
                    {#if themes=='darkred' || themes=='darkblue' || themes=='darkgold' || themes=='darkgreen' || themes=='darkorange' || themes=='darkpink' || themes=='darkpurple'}
                        <div class="w-20  m-0 p-0 btn-footer text-center btn-footer-f11" on:click={() => push('/dashboard')}>
                            <img src="../assets/icon/iconhome/{themes}-home.png" class="icon-footer-btn"/><br />
                            หน้าแรก
                        </div>
                        <div class="w-20  m-0 p-0 btn-footer text-center btn-footer-f11"  on:click={() => push('/deposit')}>
                            <img src="../assets/icon/iconhome/{themes}-deposit.png" class="icon-footer-btn"/><br />
                            ฝาก
                        </div>
                        {#if platformList.length==1 && platformList[0].platform_prefix!='UFA'}
                        <div class="w-20  m-0 p-0 btn-footer text-center "  on:click={() => push('/provider/'+platformList[0].platform_prefix+'/casino')} style="position: relative;">
                            <img src="../assets/icon/btnplay/{themes}.gif" class="img-footer-btn"/><br />
                            เข้าเล่น
                        </div>
                        {/if}
                        {#if platformList.length>1 || (platformList.length==1 && platformList[0].platform_prefix=='UFA')}
                        <div class="w-20  m-0 p-0 btn-footer text-center txtct" style="position: relative;">
                            <button type="button" on:click={() => getBalance()} class="bigbtn rounded-circle"><Fa icon={faHandHoldingDollar} size="2x"/><br/>{balance.toLocaleString('th-TH')}</button>
                        </div>
                        {/if}
                        <div class="w-20  m-0 p-0 btn-footer text-center btn-footer-f11" on:click={() => push('/withdraw')}>
                            <img src="../assets/icon/iconhome/{themes}-withdraw.png" class="icon-footer-btn"/><br />
                            ถอน
                        </div>
                        <div class="w-20  m-0 p-0 btn-footer text-center btn-footer-f11" on:click={() => push('/promotion')}>
                            <img src="../assets/icon/iconhome/{themes}-promotion.png" class="icon-footer-btn"/><br />
                            โปรโมชั่น
                        </div>
                    {:else}
                        <div class="w-20  m-0 p-0 btn-footer text-center" on:click={() => push('/dashboard')} >
                            <Fa icon={faHouse} size="lg"/><br />
                            หน้าแรก
                        </div>
                        <div class="w-20  m-0 p-0 btn-footer text-center" on:click={() => push('/deposit')}>
                            <Fa icon={faMoneyBill} size="lg"/><br />
                            ฝาก
                        </div>
                        <div class="w-20  m-0 p-0 btn-footer text-center " style="position: relative;">
                            <button type="button" on:click={() => getBalance()} class="bigbtn rounded-circle"><Fa icon={faHandHoldingDollar} size="2x"/><br/>{balance}</button>
                        </div>
                        <div class="w-20  m-0 p-0 btn-footer text-center" on:click={() => push('/withdraw')}>
                            <Fa icon={faSackDollar} size="lg"/><br />
                            
                            ถอน
                        </div>
                        <div class="w-20  m-0 p-0 btn-footer text-center" on:click={() => push('/promotion')}>
                            <Fa icon={faGifts} size="lg"/><br />
                            โปรโมชั่น
                        </div>
                    {/if}

                    
                </div>
                
            </div>
            

        </div>
    </div>
<style>
    .navbar>.content-wrapper, .content-wrapper{
		/* width: 373px!important;
    	max-width: 374px!important; */
		min-height: 100%;
		display: table;
	}
    .w-20{
        width: 18%!important;
        width: 70px;
    }
    .btn-footer{
        color: white;
        background-color: transparent;
        border: 0px;
        cursor: pointer;
    }
   .bigbtn{
        background: linear-gradient(180deg, #ecc857 0%, #cf8000 100%);
        /* position: absolute; */
        width: 75px;
        height: 75px;
        position: absolute;
        left: 0px;
        top:-30px;
        color:white;
   }

   @media only screen and (min-device-aspect-ratio:1920 / 1080){
        .navbar>.content-wrapper, .content-wrapper{
            width: 373px!important;
            max-width: 374px!important;
            min-height: 100%;
            display: table;
        }

	}
	@media only screen and (min-device-aspect-ratio:512/683){
		.navbar>.content-wrapper, .content-wrapper{
            width: 373px!important;
            max-width: 374px!important;
            min-height: 100%;
            display: table;
        }
	}



</style>
